module.exports = __webpack_public_path__ + "static/media/menu.9baca39f.svg";